<template>
  <div>
    <ui-heading tag="h4" bold bullet margin>{{
      $t("findPasswordTitle")
    }}</ui-heading>
    <ui-v ref="find-form" :rules="rules">
      <ui-input
        name="email"
        @keyup.enter.native="submit"
        type="email"
        v-model="user.email"
        :placeholder="$t('typeEmailHere')"
      >
        <ui-icon slot="prefix" name="icon-idcard"></ui-icon>
      </ui-input>
    </ui-v>
    <ui-button
      full
      v-if="!emailSent"
      type="primary"
      :loading="loading"
      @click.native="submit"
      >{{ $t("findPasswordButton") }}</ui-button
    >
    <ui-alert
      closeable
      class="mt20"
      v-if="emailSent"
      @close="
        emailSent = false;
        user.email = '';
      "
    >
      <p>{{ $t("restPasswordInstruction1") }}</p>
      <p>{{ $t("restPasswordInstruction2") }}</p>
    </ui-alert>
  </div>
</template>
<script>
import api from "../../api/index";

export default {
  data() {
    return {
      loading: false,
      emailSent: false,
      user: {
        email: ""
      },
      rules: {
        email: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("emailAddress")
          },
          {
            type: "email",
            trigger: "submit",
            message: this.$t("typeValidEmail")
          }
        ]
      }
    };
  },
  methods: {
    submit() {
      this.$refs["find-form"]
        .validate()
        .then(data => {
          this.doFind();
        })
        .catch(err => {});
    },
    doFind() {
      this.loading = true;
      api
        .forgotPassword(this.user)
        .then(response => {
          this.loading = false;
          this.emailSent = true;
        })
        .catch(err => {
          this.loading = false;
          if (err.response.status == 401) {
            this.$refs["emailInput"].error.push(this.$t("emailNotFound"));
          } else {
            throw new Error(err);
          }
        });
    }
  }
};
</script>
